import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStrategies = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Grid Plus",
		children: [
			/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse 159",
				cx: 12,
				cy: 12,
				r: 10,
				stroke: "#8A94A6",
				strokeWidth: 1.6,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse 160",
				cx: 12,
				cy: 12,
				r: 6,
				stroke: "#8A94A6",
				strokeWidth: 1.6,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse 161",
				cx: 12,
				cy: 12,
				r: 2,
				stroke: "#8A94A6",
				strokeWidth: 1.6,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})]
});
const ForwardRef = forwardRef(SvgStrategies);
export { ForwardRef as ReactComponent };
